import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { router } from './lib/router';
import { createContainer, type QueryClient } from './di/setup';
import { SettingsProvider } from './contexts/settings-context';
import './index.css';

// Load environment variables
const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
};

// Debug logging
console.log('🔧 Admin App Config:', {
  apiUrl: config.apiUrl,
  supabaseUrl: config.supabaseUrl ? `${config.supabaseUrl.substring(0, 20)}...` : 'NOT SET',
  supabaseAnonKey: config.supabaseAnonKey ? `${config.supabaseAnonKey.substring(0, 20)}...` : 'NOT SET',
  envVars: {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  },
});

// Create DI container
const container = createContainer(config);

// Get query client from container
const queryClient = container.resolve<QueryClient>('queryClient');

// Make container available globally for route loaders
(window as any).__DI_CONTAINER__ = container;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <RouterProvider router={router} />
      </SettingsProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

